export default __webpack_public_path__ + "static/media/Prasaga 2 1.1bb75af4.svg";